import { Expose } from "class-transformer";
import { CreateSubquestionDto } from "@/core/features/questions/create-subquestion.dto";

export class UpdateSubquestionDto extends CreateSubquestionDto {
  @Expose()
  id: string;
}
